"use client";

import type { AnchorHTMLAttributes, ReactNode } from "react";
import { trackContact } from "../../lib/site";

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  method: "call" | "whatsapp" | "email" | "form";
  children: ReactNode;
};

/** Plain anchor that records a GA4 generate_lead event on click. Use for tel:, mailto:, and WhatsApp links in server components. */
export default function TrackedLink({ method, children, onClick, ...rest }: Props) {
  return (
    <a
      {...rest}
      onClick={(event) => {
        trackContact(method);
        onClick?.(event);
      }}
    >
      {children}
    </a>
  );
}
